<template>
  <div class="mycomplaints" v-cloak>
    <div v-if="showPage">
      <ul class="complaints_list" v-if="complaitintList.length>0">
        <li v-for="item in complaitintList">
          <div class="title" @click="toGoodsList(item.supplierId,item.supplierShortName)">
            <div class="fl shop_icon" :style="{backgroundImage:'url('+item.shopIcon+')'}"></div>
            <div class="shop_info"><span class="fl shop_name">{{item.supplierShortName}}</span><span class="fr state">{{complainStatus[item.complainStatus]}}</span></div>
            <p class="time">{{item.date}}</p>

          </div>
          <div class="goods-list">
            <ul style="margin-top: 0.2rem">
              <li v-for="order in item.goodsList" style="margin-bottom: 0.12rem;padding-top: 0;padding-right: 0">
                <span class="fl">{{order.name}}</span>
                <span class="fr" style="color: #9B9B9B">x {{order.buyNum}}</span>
              </li>
            </ul>
            <div class="moreList" v-if="item.omit">···</div>
          </div>
          <div class="price_info clearflow">
            <p style="font-size: 0.28rem">总计<span class="pay_price" style="color: #4A4A4A;font-weight: bold">￥{{item.amount}}</span></p>
            <span @click="toCheckComplaints(item.complaintId)" class="fr btn_check">查看投诉</span>
          </div>
        </li>
      </ul>
      <div class="no-info" v-else>
        <div class="no-goods">
          <img src="../assets/images/empty-01.png" />
          <p>这里什么都没有</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {actions} from '../store/actions'
    import PreviewPicture from '../components/PreviewPicture'
    // import { MessageBox } from 'mint-ui'

  	export default {
  	  data () {
  	    return {
  	      flag:false,
          isShow:true,
          showPage:false,
          currentPage: 1,
          pageSize: 20,
          hasMore: true,
          complaitintList: [],
          complainStatus: {
            0: '待处理',
            1: '已受理',
            2: '处理完成',
            3: '已判断',
            9: '已取消'
          },
  	    }
  	  },
      created () {
        var _this = this
        // document.title = "我的投诉"
        _this.getComplaintList()

        //页面滚动到底部触发事件
        window.onscroll = function () {
          var marginBot = 0
          if (document.documentElement.scrollTop){
            marginBot = document.documentElement.scrollHeight
              -(document.documentElement.scrollTop + document.body.scrollTop)
              - document.documentElement.clientHeight
          } else {
            marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight
          }
          if(marginBot <= 0) {
            if(_this.hasMore) {
              _this.getComplaintList()
            }
          }
        };
      },
  	  methods: {
        getComplaintList: function (){
          var _this = this
          _this.hasMore = false
          var params = {
            pageSize: _this.pageSize,
            pageNo: _this.currentPage
          }
          actions.getComplaintList(_this, params, function (data) {
              _this.showPage = true
              if(data.list.length < _this.pageSize) {
                _this.hasMore = false
              } else {
                _this.hasMore = true
              }
              _this.currentPage = _this.currentPage +1;
              if(data.list.length > 0) {
                var complaintList = data.list;
                for (var i = 0; i < complaintList.length; i++) {
                  _this.complaitintList.push(complaintList[i])
                }
              }
              // console.log(_this.complaitintList)
              for(var i = 0; i < _this.complaitintList.length; i++) {
                if(_this.complaitintList[i].goodsList.length > 3) {
                  _this.complaitintList[i].goodsList = _this.complaitintList[i].goodsList.slice(0, 3);
                  _this.complaitintList[i].omit = true;
                } else {
                  _this.complaitintList[i].omit = false;
                }
              }
          })
        },
        toGoodsList:function (id,name) {
          // console.log(id,name)
          var _this = this;
          var obj = {
            shop_code: id,
            shop_name: name,
            showBlockType: 'orderDishes'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({name:'GoodsList'})
        },
  	    toCheckComplaints: function(id){
          window.localStorage.setItem('processType', 1)
          window.localStorage.setItem('complainId',id);
  	      this.$router.push({name:'CheckComplaints'})
  	    }
  	  },
      components: {
        PreviewPicture
      }
  	}
</script>



// WEBPACK FOOTER //
// MyComplaints.vue?f9ee4d90